export default "__VITE_ASSET__BRMGE0WW__"